import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import { useNavigate, useParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useState } from "react";
import { createSessions } from "../../../redux/action/messages/chat/chatAction";
import { toast } from "react-toastify";

const SendMessageBtnHome = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies(["authToken"]);
  const featuresMessages = useSelector((state) => state.messages.chat.features);
  const navigate = useNavigate();

  const params = useParams();

  const sendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (props.body.length >= 1) {
      try {
        const data = await dispatch(
          await createSessions(
            params.id,
            props.body,
            cookies.authToken,
            featuresMessages,
          ),
        );

        if (data?.status === 200) {
          navigate(
            `/messages/2/09900000000?session_id=${data.data.data.session.id}`,
          );
        } else {
          const errorMessage = data?.statusText || "ارسال پیام ناموفق بود";
          toast.error(errorMessage);
        }
      } catch (error) {
        console.error(error);
        toast.error("خطا در ارتباط با سرور");
      }
    }
    setLoading(false);
  };

  return (
    <button
      onClick={sendMessage}
      disabled={loading}
      type="submit"
      className={`w-10 h-10 mb-[5px] flex items-center justify-center bg-primary text-white flex-shrink-0 rounded-xl shadow-sm shadow-primary outline outline-2 outline-primary/10 disabled:opacity-50`}
    >
      {loading ? (
        <svg
          className="w-6 h-6 fill-white animate-spin"
          viewBox="0 0 1024 1024"
        >
          <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" />
        </svg>
      ) : (
        <ReactSVG
          src={`${process.env.PUBLIC_URL}/assets/images/icons/send.svg`}
          className="w-6 h-6"
        />
      )}
    </button>
  );
};

export default SendMessageBtnHome;
